module.exports = __webpack_public_path__ + "assets/img/EXTERNAL_PLUGIN.9d58579d.svg";